/**
 * Clients-tab view orchestrator.
 *
 * Single point of dispatch: looks at `state.selectedPatient` and
 * `state.builderMode` and routes to the right renderer (list, detail,
 * plan-builder, or objective-picker).
 *
 * Imported by every clients/* module that needs to trigger a re-render
 * — replaces the circular `from "../main"` dependency the sibling
 * modules carried during 6b.2-6b.5. Now that renderClientsView lives
 * in clients/, the dispatch graph is acyclic within the clients folder
 * (clients/list, clients/detail, clients/draft, clients/plan-builder
 * → clients/view → clients/list, clients/detail, clients/plan-builder).
 *
 * Extracted from main.ts as part of OMON-060 Phase 6b.6.
 */

import { state } from "../state";
import { renderPatientList } from "./list";
import { renderPatientDetail } from "./detail";
import {
  renderPlanBuilder,
  renderObjectivePicker,
} from "./plan-builder";

export function renderClientsView() {
  if (state.selectedPatient) {
    if (state.builderMode === "create" || state.builderMode === "edit") { renderPlanBuilder(); return; }
    if (state.builderMode === "pick") { renderObjectivePicker(); return; }
    renderPatientDetail();
  } else {
    renderPatientList();
  }
}
